import { palette } from '@core/theme/units/palette';
import { createStyles } from '@core/theme/utils/styles';

export const styles = () =>
  createStyles({
    root: {
      fontSize: '14px',
      fontWeight: 400,
      color: palette.common.black,
      wordBreak: 'break-all',
    },
  });
